import { Deserializable } from '../deserializable';

export class DooyaFiaApplication implements Deserializable {
  public id: number;
  public userId: number;
  public utcDateTimeCreated: Date;
  public utcDateTimeSubmitted: Date;
  public utcDateTimeUpdated: Date;
  public utcDateTimeCompleted: Date;
  public isComplete: boolean;
  public isDeleted: boolean;
  public isSuccess: boolean;
  public isPaused: boolean;
  public applicationState: number;
  public translatedState: string;
  public efilingAttempts: number;
  public lastEfilingFeedback: string;
  public overdueWarningSent: boolean;
  public isAutoCreatedApplication: boolean;

  public errorMessage: string;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
